export default class MAuth
{
	static getAccessToken()
	{
		return _config.accessToken;
	}

	static getAccessTokenHeaderValue()
	{
		return `Bearer ${_config.accessToken}`;
	}

	static getAccessTokenHeaders()
	{
		return {
			Authorization: this.getAccessTokenHeaderValue(),
		};
	}
}
